import httpRequest from 'utils/httpRequest';

import SETTINGS from '../settings';

const withNextApiHeaders = headers => ({
  'Content-Type': 'application/json',
  // TODO append also buildId as a header
  'X-ASG': 'parabo-next',
  'X-User-Agent': SETTINGS.USER_AGENT,
  ...headers,
});

const withNextApiHost = url => {
  let host = SETTINGS.HOST;
  if (typeof window === 'undefined') {
    host = process.env.LOCAL_DATA_API_HOST ?? host;
  }
  return `${host}${url}`;
}

const nextApiGetRequest = async (url, headers = {}) => {
  const response = await httpRequest(withNextApiHost(url), {
    method: 'GET',
    headers: withNextApiHeaders(headers),
  });

  return response;
};

export default nextApiGetRequest;
